import Vue from 'vue';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js';
import { getFullUrl } from './url';
import { formatDate } from './date';
import ImportantMessagesModal from '../components/ImportantMessagesModal';
import { hasPermission } from './permissions';

function initApp(config) {
  Vue.config.productionTip = false;
  Vue.prototype.$url = getFullUrl;
  Vue.prototype.$formatDate = formatDate;
  Vue.prototype.$hasPermission = hasPermission;

  Vue.component('ImportantMessagesModal', ImportantMessagesModal);

  if (window.vueAppConfig.useKeycloak) {
    // Keycloak only works via a proxy to our staging server
    // And will only be required in staging
    // The extra check for NODE_ENV is so keycloak is never used for local development
    // when launching the app with npm run serve.
    // Otherwise you need to keep changing VUE_APP_ENVIRONMENT the value in .env
    // before running npm run build when testing changes with connection to EPTP test server

    const keyCloakOptions = {
      config: {
        realm: window.vueAppConfig.keycloakClientRealm,
        url: window.vueAppConfig.keycloakAuthUrl,
        clientId: window.vueAppConfig.keycloakClientId,
      },
      onReady: () => {
        new Vue(config).$mount('#app');
      },
    };
    if (config.isPublic) {
      keyCloakOptions.init = {
        onLoad: 'check-sso',
      };
    }
    Vue.use(VueKeyCloak, keyCloakOptions);
  } else {
    new Vue(config).$mount('#app');
  }
}

export default initApp;
